import React from 'react'
import styled from 'react-emotion'
import { spacer, Button, Form } from 'stylist'
import serializeErrorMessages from 'utils/serializeErrorMessages'
import { Box, withNotifier } from 'stylist'
import Field from 'components/fields'
import withMutate from 'components/withMutate'

const SpacedButton = styled(Button)`
  margin-left: ${spacer(2)};
`

const fieldValue = field =>
  field.value || (field.type === 'boolean' ? false : '')

const buildInitialValues = (record, fields) =>
  fields.reduce(
    (acc, field) => ({
      ...acc,
      [field.name]: record
        ? record[field.name] || fieldValue(field)
        : fieldValue(field)
    }),
    {}
  )

const FormForRecordForm = ({
  record,
  fields,
  schema,
  backPath,
  variables,
  mutationArgs,
  notify,
  onSuccess,
  history,
  title,
  onCancel,
  mutate
}) => (
  <Box>
    <Box.Item pad>
      <Form
        initialValues={buildInitialValues(record, fields)}
        validationSchema={schema}
        redirect={backPath}
        onSubmit={props => {
          const id = record && record.id
          const data = fields.reduce(
            (acc, field) =>
              field.type === 'immutable'
                ? acc
                : {
                    ...acc,
                    [field.name]: props[field.name]
                  },
            {}
          )

          return mutate({
            variables: {
              id,
              ...variables,
              data: { ...data, ...(variables ? variables.data : {}) }
            },
            ...mutationArgs
          })
            .then(() => notify('success', 'Saved'))
            .then(onSuccess)
            .catch(e => Promise.reject(serializeErrorMessages(e)))
        }}
      >
        <Form.Errors />

        <Form.Title>{title}</Form.Title>
        {fields.map((field, key) => <Field field={field} key={key} />)}
        <Form.Group buttons>
          <Form.SubmitButton>Save</Form.SubmitButton>
          <SpacedButton
            onClick={e => {
              e.preventDefault()
              if (onCancel) {
                onCancel()
              } else if (backPath) {
                history.replace(backPath)
              }
            }}
          >
            Cancel
          </SpacedButton>
        </Form.Group>
      </Form>
    </Box.Item>
  </Box>
)

const FormForRecord = props => {
  if (!props.mutate && !props.mutation) {
    throw new Error('You must send either a mutation or a mutate function')
  }

  const Component = props.mutate
    ? FormForRecordForm
    : withMutate(props.mutation)(FormForRecordForm)

  return <Component {...props} />
}

FormForRecord.defaultProps = {
  mutationArgs: {},
  onSuccess: () => {}
}

export default withNotifier(FormForRecord)



// WEBPACK FOOTER //
// ./src/components/FormForRecord.js